import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { DebtCapacityConfig } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useCurrentRatesQuery(
	options?:
		| Omit<UseQueryOptions<DebtCapacityConfig, unknown, DebtCapacityConfig, any>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Matching.Rates(),
		() => AxiosUtils.getResponseData<DebtCapacityConfig>(api.get(CerebroApiEndpoints.Matching.Rates())),
		options
	);
}
